let currentAccessToken = null;
let currentIdToken = null;
let expiresAtSeconds = 0;

export const setAccessToken = (token, expiresAt) => {
  currentAccessToken = token || null;
  expiresAtSeconds = expiresAt ?? 0;
};

export const setIdToken = (token) => {
  currentIdToken = token || null;
};

export const clearAccessToken = () => {
  currentAccessToken = null;
  currentIdToken = null;
  expiresAtSeconds = 0;
};

export const getAccessToken = () => currentAccessToken;
export const getIdToken = () => currentIdToken;

export const isAccessTokenExpired = () => {
  if (!currentAccessToken) return true;
  if (!expiresAtSeconds) return false;
  return expiresAtSeconds * 1000 < Date.now();
};
